import React, { Component } from 'react';
import {
	Row, Col, Form, FormGroup,
	Input, Label,
} from 'reactstrap';

class UserProfileForm extends Component {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(e) {
		console.log(e.target.value);
	}

	render() {
		return (
			<Form>
				<Row>
					<Col>
						<FormGroup>
							<Label for="age">Age</Label>
							<Input type="text" name="age" id="age" placeholder="Your age" onChange={this.handleChange} />
						</FormGroup>
					</Col>
					<Col>
						<FormGroup>
							<Label for="gender">Gender</Label>
							<Input type="select" name="gender" id="gender" onChange={this.handleChange}>
								<option value="" disabled selected>Choose one...</option>
								<option value="male">Male</option>
								<option value="female">Female</option>
								<option value="undisclosed">I&apos;d rather not say</option>
							</Input>
						</FormGroup>
					</Col>
				</Row>
				<FormGroup>
					<Input type="email" name="email" id="email" placeholder="Your email" onChange={this.handleChange} />
				</FormGroup>
				<p>We will use this information <em>only</em> to help tailor recommended activities and to send you the results.</p>
			</Form>
		);
	}
}

export default UserProfileForm;



// WEBPACK FOOTER //
// ./src/UserProfileForm.jsx